export const NAMESPACE = 'telco';
export const RESOURCE = 'fibers';
